'use strict';

function getUrlId(url) {
	if (!url) {
		url = window.location.href;
	}

	return url.slice(url.lastIndexOf('#'));
}

module.exports = getUrlId;
